// Libellés et couleurs partagés par les pages du module Sacrifices

export const statutLabel = {
  en_attente: "En attente",
  validee_local: "Validée localement",
  mandat_envoye: "Mandat envoyé",
  mandats_acceptes: "Mandats acceptés",
};

export const statutColor = {
  en_attente: "#fb8c00",
  validee_local: "#1976d2",
  mandat_envoye: "#7b1fa2",
  mandats_acceptes: "#43a047",
};

// Statut suivant pour le directeur / délégué
export const statutSuivantLocal = {
  en_attente: { statut: "validee_local", label: "Valider", icon: "check_circle" },
  validee_local: { statut: "mandat_envoye", label: "Envoyer le mandat", icon: "send" },
};

export const typeAnimalLabel = {
  ovins_caprins: "Ovins / Caprins",
  vache: "Vache",
  chameau: "Chameau",
};

export const causeLabel = {
  oudhiya: "'Oudhiya",
  aqiqah: "'Aqiqah",
  defunt: "En faveur d'un défunt",
  nadhr: "Nadhr / Vœu",
};

export const fmtEuro = (n) =>
  parseFloat(n || 0).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + " €";

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("fr-FR") : "—");

// Chip pastel : fond teinté + texte dans la couleur pleine
export const chipPastel = (color) => ({
  bgcolor: color + "22",
  color,
  fontWeight: "bold",
  border: "1px solid " + color + "55",
});
